// Copyright (c) 2025 Deere & Company

import t from 'tcomb';

const RgaQuestionAnswer = t.struct({
    answer: t.String,
    question: t.String
}, {
    name: 'RgaQuestionAnswer',
    strict: true
});

export const getDefaultState = () => new RgaQuestionAnswer({
    answer: '',
    question: ''
});

export default RgaQuestionAnswer;



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/state/rga-question-answer.js